import createCrudApi from "@/app/services/baseApi";
const componentesApi = createCrudApi('componentes');

export default componentesApi;
